import { helpers } from "vuelidate/lib/validators";

export default (types) =>
  helpers.withParams(
    { types: "fileTypes" },
    (value) =>
      value !== null && value !== undefined && types.includes(value.type)
  );
